<template>
  <vue-final-modal name="alarm-list-modal" class="alarm-list-modal"
                   v-model="show"
         :width="'100%'"
         :height="'auto'"
         transition="modal-bottom"
         :pivotY="0.5"
         @before-open="handlerBeforeOpen"
         @before-close="handlerBeforeClose"
  >
    <div class="alarm-list-wrap">
      <div class="alarm-header">
        <span class="alarm-title">알림</span>
        <el-button class="alarm-total-delete">전체삭제</el-button>
      </div>
      <div class="alarm-list-container">
        <ul class="alarm-list-area">
          <li v-for="data in 20">
            <div class="alarm-list-date">오늘</div>
            <div class="alarm-list-content">
              <div class="user-profile"></div>
              <div class="alarm-content-box">
                <div class="alarm-content items">
                  <div class="alarm-user-info">
                    <span class="user-nickname">닉네임은열글자입니다 님</span>
                  </div>
                  <button class="alarm-delete-btn"></button>
                </div>
                <div class="alarm-content">
                  알림알림알림알림알림알림알림알림알림알림알림알림알림알림알림알림알림알림
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </vue-final-modal>
</template>

<script>
export default {
  name: "AlarmListModal",
  mixins: [],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
        show: false
    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
  },
  beforeUnmount() {
  },
  unmounted() {
  },
  computed: {},
  methods: {
    handlerBeforeOpen() {
    },
    handlerBeforeClose() {
    },
    modalClose() {
      this.$modal.hide('alarm-list-modal');
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>
